import React, { useEffect, useState } from "react";
import { observer } from "mobx-react-lite";
import { Box, setPageTitle } from "Application";
import { PastMentorsViewModel } from "./PastMentorsViewModel";
import { PageRoot, PageContainer } from "Styles/PageStyles";
import { PastMentorsTable } from "./PastMentorsTable";

export const PastMentorsView: React.FC = observer(() => {
    const [viewModel] = useState(new PastMentorsViewModel());

    useEffect(() => {
        setPageTitle("Past Mentors");
        viewModel.getFilteredMentors();
        return () => {
            viewModel.reset();
        };
    }, []);

    return (
        <>
            <PageRoot style={{ background: "#fff" }}>
                <PageContainer>
                    <PastMentorsTable mentors={viewModel.mentors} onViewMentorDetailsCommand={viewModel.navigateToMentorDetailsCommand} />
                </PageContainer>
            </PageRoot>
        </>
    );
});
